<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <br>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-data-table :headers="headers" :items="default_values_list" class="elevation-1 mytable" id="mytable"
      :search="search">
      <template v-slot:top>
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Default Values</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details
            :style="{ 'background-color': 'white', 'color': 'black' }">
          </v-text-field>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="success" small :disabled="isallowed == false ? true : false" v-on="on">Add Default Value</v-btn>
            </template>
            <v-card>
              <v-form v-model="valid">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-select dense rounded outlined v-model="editedItem.default_type"
                          @change="admission_schedule(editedItem.default_type)" :items="default_type_value_list"
                          :readonly="editedIndex == -1 ? false : true" item-text="default_type" item-value="id"
                          label="Default Value Type" persistent-hint :disabled="editedIndex != -1"
                          :filled="editedIndex == -1 ? false : true" return-object single-line
                          color="#0F2027"></v-select>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-row dense>
                          <v-text-field outlined rounded dense v-model="editedItem.default_value" color="#0F2027"
                            persistent-hint :hint="editedIndex == -1
                            ? 'For example :: Exam, SMS...'
                            : 'For example ::  Exam, SMS...'
                            " label="Enter Default Value" :rules="[(v) => !!v || 'required']">
                          </v-text-field>
                          <div
                            v-if="editedItem.default_type =='ADMISSION-SCHEDULING-TIME' || editedItem.default_type == 'Transport-Declaration-SBPPS'"
                            class="ml-5 mt-2">
                            <v-avatar style="" size="25" class="edit-avatar">
                              <v-icon class="edit-v-icon mr-2"
                                @click="admission_schedule(editedItem.default_type)">edit</v-icon>
                            </v-avatar>
                          </div>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined rounded dense v-model="editedItem.other" color="#0F2027" persistent-hint
                          label="Enter Other Value" :rules="[(v) => !!v || 'required']">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined rounded dense v-model="editedItem.min_value" color="#0F2027"
                          persistent-hint label="Enter Min Value" :rules="[(v) => !!v || 'required']">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined rounded dense v-model="editedItem.max_value" color="#0F2027"
                          persistent-hint label="Enter Max Value" :rules="[(v) => !!v || 'required']">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined rounded dense v-model="editedItem.sort_order" color="#0F2027"
                          persistent-hint label="Enter Sort Order" :rules="[(v) => !!v || 'required']">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-checkbox dense v-model="editedItem.isactive" color="#0f2027" label="Is Active?"></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-checkbox dense v-model="editedItem.isdefault" color="#0f2027" label="Is Default?"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <v-btn small class="no-display ml-2" rounded color="white" outlined
          @click="fnExcelReport('mytable', 'DefaultValues')"><v-icon color="white">mdi-export</v-icon>Export</v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.isactive="{ item }">
        <span v-if="item.isactive">
          <v-icon small class="mr-2" color="success">mdi-check-circle-outline</v-icon>
        </span>
        <span v-else>
          <v-icon small class="mr-2" color="error">mdi-close-circle-outline</v-icon>
        </span>
      </template>
      <template v-slot:item.isdefault="{ item }">
        <span v-if="item.isdefault">
          <v-icon small class="mr-2" color="success">mdi-check-circle-outline</v-icon>
        </span>
        <span v-else>
          <v-icon small class="mr-2" color="error">mdi-close-circle-outline</v-icon>
        </span>
      </template>
      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
          </v-avatar>
        </div>
      </template>
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="dialog_admission" fullscreen>
      <v-card>
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong> Add Default Value </strong>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn fab small color="white" outlined icon @click="dialog_admission = false"><v-icon> mdi-close
            </v-icon></v-btn>
        </v-toolbar>
        <v-card>
          <v-col>

            <v-card-text>
              <v-card>
                <v-card-text>
                  <v-textarea outlined name="input-7-4" label="HTML Code..." auto-grow
                    v-model="editedItem.default_value" ref="ta"></v-textarea>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-card-text>
              <v-card>
                <v-card-title>Preview</v-card-title>
                <v-card-text>
                  <div id="preview" ref="content" v-html="editedItem.default_value"></div>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-col>
        </v-card>
        <br />

      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    isallowed:false,
    valid: false,
    overlay: false,
    errorMsg: {
      id: false,
    },
    snackbar_msg: "",
    extraBreadcrumbItems: [
     

    ],
    breadcrumbClass: "breadcrumb-style1",

    color: "",
    snackbar: false,
    search: "",
    dialog_admission: false,
    headers: [
      {
        text: "Default Value",
        align: "left",
        sortable: false,
        value: "default_value",
      },
      {
        text: "Default Value Type",
        align: "left",
        sortable: false,
        value: "default_type",
      },
      {
        text: "Other Value",
        align: "left",
        sortable: false,
        value: "other",
      },
      {
        text: "Min Value",
        align: "left",
        sortable: false,
        value: "min_value",
      },
      {
        text: "Max Value",
        align: "left",
        sortable: false,
        value: "max_value",
      },
      {
        text: "Sort Order",
        align: "left",
        sortable: false,
        value: "sort_order",
      },
      { text: "Is Active ?", value: "isactive", sortable: false },
      { text: "Is Default ?", value: "isdefault", sortable: false },
      { text: "Actions", value: "action", sortable: false },
    ],
    default_values_list: [],
    default_type_value_list: [],
    editedIndex: -1,
    dialog:false,
    editedItem: {
      id: "",
      default_value: "",
      default_type: "",
      isactive: true,
      isdefault: true,
      max_value: "",
      min_value: "",
      sort_order:"",
      other:""
    },
    defaultItem: {
      id: "",
      default_value: "",
      default_type: "",
      isactive: true,
      isdefault: true,
      max_value: "",
      min_value: "",
      sort_order:"",
      other:""
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Default Value"
        : "Edit Default Value";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
          $(elem).remove();
      });
       exportTable.find('th, td').each(function() {
          $(this).css('border', '1px solid black');
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
      const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const filename = name + ".xls";

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // For IE
          window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
          // For modern browsers
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
      }
    },
    admission_schedule(default_type){
        if(default_type == 'ADMISSION-SCHEDULING-TIME' || default_type == 'Transport-Declaration-SBPPS'){
            this.dialog_admission = true
        }
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/RoleManagement/adminDefaultValue")
        .then((res) => {
          if (res.data.flag == "YES") {
            if ((this.load = true)) {
              this.overlay = false;
              this.default_values_list = res.data.default_values_list;
              this.default_type_value_list = res.data.default_type_value_list;
               this.isallowed=res.data.isallowed
            }
          }else if (res.data.flag == "No"){
              this.showSnackbar("red", res.data.snackbar);
              this.isallowed=res.data.isallowed
              this.overlay = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.default_values_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/RoleManagement/editAdminDefaultValue", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                Object.assign(
                  this.default_values_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "Default Value Updated Successfully..."
                ); // show snackbar on success
              } else if (res.data.status.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  "Default Value Already Present!!!"
                ); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        axios
          .post("/RoleManagement/saveAdminDefaultValue", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.default_values_list.push(this.editedItem);
              this.showSnackbar(
                "#4caf50",
                "Default Value Added Successfully..."
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Default Value Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.id) {
        return true;
      } else {
        if (!this.editedItem.id) {
          this.errorMsg.id = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}
</style>
